import { BareActionContext } from 'vuex-typex'
import { PostState } from '@/store/post/state'
import { RootState } from '@/store'
import postStore from '@/store/post/post-store'
import feedStore from '@/store/feed/feed-store'
import { PostSearchForm } from '@/model/search/search-query'
import setPostQuery from '@/store/post/actions/set-post-query';

export default async function initFetchPosts(context: BareActionContext<PostState, RootState>)
{
    postStore.state.posts = []
    postStore.state.postSearchForm = new PostSearchForm()

    setPostQuery(context)

    return
}
